<div class="embed-builder" *ngIf="signupTemplate">
  <mat-accordion multi class="form-accordion">
    <mat-expansion-panel expanded class="expansion-panel-general">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="panel-title-content">
            <mat-icon class="panel-icon">tune</mat-icon>
            <span>General Settings</span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="emojiForm" class="form-container">
        <div class="form-section">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Template Title</mat-label>
            <input matInput formControlName="signupTemplateTitle" placeholder="e.g., Dungeon Run" />
            <mat-hint>Choose a descriptive name for your template (max 25 characters)</mat-hint>
            <mat-error *ngIf="emojiForm.get('signupTemplateTitle').errors?.required">This field is required</mat-error>
            <mat-error *ngIf="emojiForm.get('signupTemplateTitle').errors?.minlength">Title is too short (min. 1 character)</mat-error>
            <mat-error *ngIf="emojiForm.get('signupTemplateTitle').errors?.maxlength">Title is too long (max. 25 characters)</mat-error>
          </mat-form-field>

          <div class="emoji-picker-row">
            <mat-label class="emoji-picker-label">Template Icon</mat-label>
            <app-emoji-picker-button class="emoji-picker-component" [customEmojis]="serverCustomEmojis"
              [defaultEmoji]="emojiForm.get('signupTemplateIcon').value"
              (emojiSelected)="emojiForm.get('signupTemplateIcon').setValue($event)">
            </app-emoji-picker-button>
          </div>

          <mat-form-field appearance="fill" class="full-width color-picker-field">
            <mat-label>Event Embed Color</mat-label>
            <div class="color-picker-wrapper">
              <input matInput type="color" formControlName="signupTemplateColor" 
                     [attr.aria-label]="'Event embed color picker. Current color: ' + emojiForm.get('signupTemplateColor').value" />
              <input matInput type="text" [value]="emojiForm.get('signupTemplateColor').value" 
                     (input)="emojiForm.get('signupTemplateColor').setValue($event.target.value)" 
                     class="color-hex-input" placeholder="#000000" />
            </div>
            <mat-hint>Color used for the Discord embed border</mat-hint>
            <mat-error *ngIf="emojiForm.get('signupTemplateColor').errors?.required">Color is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Emoji Behavior</mat-label>
            <mat-select formControlName="signupTemplateEmojiBehavior">
              <mat-option [value]="'1'">All emojis on top level (max 20 emojis)</mat-option>
              <mat-option [value]="'2'">Signup to sub emojis via emoji (max 20x20 emojis)</mat-option>
              <mat-option [value]="'3'">Signup to sub emojis via number (max 20x<code>infinity</code> emojis)</mat-option>
            </mat-select>
            <mat-hint>Defines how users interact with emojis</mat-hint>
          </mat-form-field>

          <div class="toggle-group">
            <mat-slide-toggle class="toggle-item" formControlName="signupTemplateEmojiTitle"
              [checked]="signupTemplateEmojiTitle">
              <span class="toggle-label-text">Display top level emojis next to field title</span>
            </mat-slide-toggle>
            
            <mat-slide-toggle class="toggle-item deprecated-toggle" formControlName="signupTemplateUseButtons"
              [checked]="signupTemplateUseButtons">
              <span class="toggle-label-text">Use Buttons instead of Emojis</span>
              <mat-icon class="deprecated-icon" matTooltip="This feature is deprecated and may be removed in the future">warning</mat-icon>
            </mat-slide-toggle>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
    <mat-expansion-panel expanded class="expansion-panel-emojis">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="panel-title-content">
            <mat-icon class="panel-icon">tag_faces</mat-icon>
            <span>Emojis</span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="emojiForm">
        <div formArrayName="emojis" cdkDropList (cdkDropListDropped)="drop($event)" class="emoji-list-container">
          <div *ngFor="let emojiCtrl of emojis.controls; let i = index" [formGroupName]="i" cdkDrag class="emoji-group">
            <div class="emoji-row" [class.has-errors]="emojiCtrl.get('emoji').invalid">
              <fa-icon *ngIf="isDesktop" [icon]="faIcons.bars" class="drag-handle" cdkDragHandle 
                       [attr.aria-label]="'Drag to reorder emoji ' + (i + 1)"></fa-icon>

              <div class="emoji-controls">
                <mat-form-field class="emoji-type-field">
                  <mat-label>Type</mat-label>
                  <mat-select formControlName="type" panelClass="emoji-type-select">
                    <mat-option value="role">Role</mat-option>
                    <mat-option value="status">Status</mat-option>
                    <mat-option [value]="'remove'" [disabled]="isTypeSelected('remove')">Sign Off</mat-option>
                    <mat-option [value]="'late'" [disabled]="isTypeSelected('late')">Late (+5 min)</mat-option>
                    <mat-option [value]="'rlate'" [disabled]="isTypeSelected('rlate')">Remove Late Status</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="emojiCtrl.value.type === 'role' || emojiCtrl.value.type === 'status' || emojiCtrl.get('fieldName').hasError('comma')" class="emoji-description-field">
                  <mat-label>Description</mat-label>
                  <input matInput formControlName="fieldName" required placeholder="e.g. Tank">
                  <mat-error *ngIf="emojiCtrl.get('fieldName').hasError('required')">Description is required</mat-error>
                  <mat-error *ngIf="emojiCtrl.get('fieldName').hasError('comma')">Description cannot contain commas</mat-error>
                </mat-form-field>

                <app-emoji-picker-button class="emoji-picker-component" [customEmojis]="serverCustomEmojis"
                  [defaultEmoji]="emojiCtrl.value.emoji" [resetSignal]="resetSignal"
                  (emojiSelected)="handleEmojiSelection(emojiCtrl.get('emoji'), $event, i, false)">
                </app-emoji-picker-button>

                <div class="emoji-errors">
                  <mat-icon *ngIf="emojiCtrl.get('emoji').hasError('duplicate')" 
                            class="error-icon" 
                            color="warn"
                            matTooltip="Duplicate emoji detected">error</mat-icon>
                  <mat-icon *ngIf="emojiCtrl.get('emoji').hasError('emojiLimit')" 
                            class="error-icon" 
                            color="warn"
                            matTooltip="Emoji limit exceeded">error</mat-icon>
                </div>

                <button mat-icon-button color="warn" (click)="removeEmoji(i)" 
                        [attr.aria-label]="'Remove emoji ' + (i + 1)"
                        class="remove-button">
                  <fa-icon [icon]="faIcons.trash"></fa-icon>
                </button>
              </div>
            </div>

            <div formArrayName="subEmojis" cdkDropList (cdkDropListDropped)="dropSubEmoji($event, i)" class="sub-emoji-container">
              <div *ngFor="let subEmojiCtrl of emojiCtrl.get('subEmojis').controls; let j = index" [formGroupName]="j"
                class="sub-emoji-row" cdkDrag [class.has-errors]="subEmojiCtrl.get('emoji').invalid">
                <fa-icon *ngIf="isDesktop" [icon]="faIcons.bars" class="drag-handle" cdkDragHandle
                         [attr.aria-label]="'Drag to reorder sub-emoji ' + (j + 1)"></fa-icon>
                
                <div class="sub-emoji-controls">
                  <mat-form-field class="sub-emoji-description-field">
                    <mat-label>Sub Emoji Description</mat-label>
                    <input matInput formControlName="fieldName" required placeholder="e.g. Knight">
                    <mat-error *ngIf="subEmojiCtrl.get('fieldName').hasError('required')">Description is required</mat-error>
                    <mat-error *ngIf="subEmojiCtrl.get('fieldName').hasError('comma')">Description cannot contain commas</mat-error>
                  </mat-form-field>

                  <app-emoji-picker-button class="emoji-picker-component" [customEmojis]="serverCustomEmojis"
                    [defaultEmoji]="subEmojiCtrl.value.emoji" [resetSignal]="resetSignal"
                    (emojiSelected)="handleEmojiSelection(subEmojiCtrl.get('emoji'), $event, i, true)">
                  </app-emoji-picker-button>

                  <div class="emoji-errors">
                    <mat-icon *ngIf="subEmojiCtrl.get('emoji').hasError('duplicate')" 
                              class="error-icon" 
                              color="warn"
                              matTooltip="Duplicate emoji detected">error</mat-icon>
                    <mat-icon *ngIf="subEmojiCtrl.get('emoji').hasError('emojiLimit')" 
                              class="error-icon" 
                              color="warn"
                              matTooltip="Emoji limit exceeded">error</mat-icon>
                    <mat-icon *ngIf="subEmojiCtrl.get('emoji').hasError('subEmojiLimit')" 
                              class="error-icon" 
                              color="warn"
                              matTooltip="Sub-Emoji limit exceeded">error</mat-icon>
                  </div>

                  <button mat-icon-button color="warn" (click)="removeSubEmoji(i, j)"
                          [attr.aria-label]="'Remove sub-emoji ' + (j + 1)"
                          class="remove-button">
                    <fa-icon [icon]="faIcons.trash"></fa-icon>
                  </button>
                </div>
              </div>
              <button *ngIf="emojiCtrl.value.type === 'role' || emojiCtrl.value.type === 'status'" 
                      class="add-sub-emoji-button"
                      mat-stroked-button 
                      color="primary" 
                      (click)="addSubEmoji(i)">
                <mat-icon>add</mat-icon>
                Add Sub Emoji
              </button>
            </div>
          </div>
        </div>

          <div class="add-emoji-button-container">
            <button mat-raised-button 
                    color="accent" 
                    (click)="addEmoji()" 
                    [disabled]="emojis.length >= 20"
                    class="add-emoji-button">
              <mat-icon>add</mat-icon>
              Add Top Level Emoji
            </button>
            <div class="emoji-count-hint" *ngIf="emojis.length >= 20">
              <mat-icon class="hint-icon">info</mat-icon>
              <span>Maximum of 20 emojis allowed</span>
            </div>
            <div class="emoji-count-hint" *ngIf="emojis.length < 20">
              <span>{{ emojis.length }} / 20 emojis</span>
            </div>
          </div>
      </form>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="panel-title-content">
            <mat-icon class="panel-icon">tune</mat-icon>
            <span>Limits</span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="limits-intro">
        <p>Apply sign up limits to fields to control participation.</p>
        <ul class="limits-hints">
          <li><code>0</code> means that no limits apply to that field.</li>
          <li>Limits higher up in the <a href="https://docs.raidorganizer.org/signup-templates/create-template/#hierarchy"
              target="_blank">hierarchy</a> will be applied first.</li>
        </ul>
      </div>
      
      <div class="limits-section">
        <h5 class="limits-section-title">General Limits</h5>
      <form [formGroup]="emojiForm">
        <div formGroupName="generalLimits">
          <div *ngFor="let limit of generalSignupLimits">
            <mat-form-field class="full-width">
              <mat-label>{{ limit.longName }}</mat-label>
              <input type="number" matInput [formControlName]="limit.key" min="0">
              <mat-error *ngIf="emojiForm.get('generalLimits').get(limit.key).invalid">
                Please enter a valid number
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
      </div>

      <div class="limits-section">
        <h5 class="limits-section-title">Field Limits</h5>
      <form [formGroup]="emojiForm">
        <div formArrayName="emojis">
          <div *ngFor="let emojiCtrl of emojis.controls; let i = index" [formGroupName]="i">
            <div *ngIf="emojiCtrl.get('type').value === 'role' || emojiCtrl.get('type').value === 'status'">
              <div class="emoji-limits-row">
                <mat-form-field class="">
                  <mat-label for="mainEmojiLimit">{{ emojiCtrl.get('fieldName').value }}</mat-label>
                  <div class="emoji-limit-input">
                    <input class="form-control" type="number" matInput formControlName="limit" min="0">
                    <mat-error *ngIf="emojiCtrl.get('limit').invalid">
                      Please enter a valid number
                    </mat-error>
                  </div>
                </mat-form-field>
              </div>

              <div formArrayName="subEmojis">
                <div *ngFor="let subEmojiCtrl of emojiCtrl.get('subEmojis').controls; let j = index"
                  [formGroupName]="j">
                  <div class="emoji-limits-row sub-emoji">
                    <mat-form-field class="">
                      <mat-label for="subemojiLimit">{{ emojiCtrl.get('fieldName').value }}, {{
                        subEmojiCtrl.get('fieldName').value }}</mat-label>
                      <div class="emoji-limit-input">
                        <input class="form-control" type="number" matInput formControlName="limit" min="0">
                        <mat-error *ngIf="subEmojiCtrl.get('limit').invalid">
                          Please enter a valid number
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Action Buttons -->
  <div class="action-buttons-container">
    <!-- Breaking Change Warning Banner -->
    <mat-card *ngIf="isFormDirty && signupTemplateId !== null && isBreakingChange" class="warning-banner" appearance="outlined">
      <mat-card-content>
        <div class="warning-content">
          <mat-icon class="warning-icon" color="warn">warning</mat-icon>
          <div class="warning-text">
            <strong>Breaking Change Detected</strong>
            <p>You've edited the Emoji Behavior or Emojis. This will affect existing events using this template.</p>
          </div>
          <button mat-stroked-button color="warn" (click)="openEditSignupTempalteDangerDialog()">
            Review Impact
          </button>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="template-actions">
      <div class="template-actions-main">
        <button mat-raised-button
                color="primary"
                *ngIf="signupTemplateId === null || isFormDirty"
                [disabled]="!isFormDirty || !emojiForm.valid"
                (click)="saveTemplate()"
                class="save-button">
          <mat-icon>{{ signupTemplateId === null ? 'add' : 'save' }}</mat-icon>
          <span>{{ signupTemplateId === null ? 'Create Template' : 'Update Template' }}</span>
        </button>
        <div class="form-status" *ngIf="signupTemplateId !== null && !isFormDirty && emojiForm.valid">
          <mat-icon class="status-icon">check_circle</mat-icon>
          <span>All changes saved</span>
        </div>
        <div class="form-status error" *ngIf="isFormDirty && !emojiForm.valid">
          <mat-icon class="status-icon">error</mat-icon>
          <span>Please fix errors before saving</span>
        </div>
      </div>

      <div class="template-actions-side" *ngIf="signupTemplateId !== null">
        <span class="share-button-wrap"
              [matTooltip]="isFormDirty ? 'Save changes before sharing' : 'Sharing makes this template public. Other servers can browse and import it.'"
              matTooltipPosition="above">
          <button mat-stroked-button
                  color="primary"
                  [disabled]="isFormDirty"
                  (click)="shareTemplate()"
                  class="share-button">
            <mat-icon>share</mat-icon>
            <span>Share to catalogue</span>
          </button>
        </span>
        <button mat-stroked-button
                color="warn"
                (click)="deleteTemplate()"
                class="delete-button">
          <fa-icon [icon]="faIcons.trash"></fa-icon>
          <span>Delete Template</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #editSignupTemplateDangerDialog>
  <h1 mat-dialog-title>Warning</h1>
  <div mat-dialog-content>
    <p>You have edited either the <code>Emoji Behavior</code> or an <code>Emoji</code>!</p>
    <p>Changing one of those will break all existing entries that use this template.
      The entries affected are:
    </p>
    <ng-container *ngIf="signupTemplate?.used_by; else noEntries">
      <div *ngIf="getEventEntries().length > 0">
        <h2>Events</h2>
        <ul>
          <li *ngFor="let event of getEventEntries()">
            <a href="https://discord.com/channels/{{ guildId }}/{{ event.channel_id }}/{{ event.message_id }}"
              target="_blank">
              {{ event.title }}
            </a>
          </li>
        </ul>
      </div>
      <div *ngIf="getRepeatingEventEntries().length > 0">
        <h2>Repeating Events</h2>
        <ul>
          <li *ngFor="let repeatingEvent of getRepeatingEventEntries()">
            <code>{{ repeatingEvent.id }}</code>{{ repeatingEvent.title }}
          </li>
        </ul>
      </div>
      <div *ngIf="getEventTemplateEntries().length > 0">
        <h2>Event Templates</h2>
        <ul>
          <li *ngFor="let eventTemplate of getEventTemplateEntries()">
            <code>{{ eventTemplate.id }}</code>{{ eventTemplate.title }}
          </li>
        </ul>
      </div>
      <div *ngIf="getSignupGroupEntries().length > 0">
        <h2>Signup Groups</h2>
        <ul>
          <li *ngFor="let signupGroup of getSignupGroupEntries()">
            <a href="http://localhost:53134/guilds/437984985547538434/signup-group/{{ signupGroup.id }}"
              target="_blank">
              {{ signupGroup.title }}
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-template #noEntries>
      <h2>None</h2>
    </ng-template>
  </div>
  <div mat-dialog-actions class="dialog-actions" *ngIf="showConfirmButtons">
    <button mat-button (click)="dialogEditTemplateRef.close(false)">Cancel</button>
    <button mat-button color="warn" (click)="confirmEditAction()">Confirm</button>
  </div>
</ng-template>

<ng-template #deleteSignupTemplateDangerDialog>
  <h1 mat-dialog-title>Delete template</h1>
  <div mat-dialog-content>
    <p *ngIf="!hasTemplateUsages">Delete this template? This cannot be undone.</p>
    <ng-container *ngIf="hasTemplateUsages">
      <p>Deleting this template will break existing entries that use it.</p>
      <div *ngIf="getEventEntries().length > 0">
        <h2>Events</h2>
        <ul>
          <li *ngFor="let event of getEventEntries()">
            <a href="https://discord.com/channels/{{ guildId }}/{{ event.channel_id }}/{{ event.message_id }}"
              target="_blank">
              {{ event.title }}
            </a>
          </li>
        </ul>
      </div>
      <div *ngIf="getRepeatingEventEntries().length > 0">
        <h2>Repeating Events</h2>
        <ul>
          <li *ngFor="let repeatingEvent of getRepeatingEventEntries()">
            <code>{{ repeatingEvent.id }}</code>{{ repeatingEvent.title }}
          </li>
        </ul>
      </div>
      <div *ngIf="getEventTemplateEntries().length > 0">
        <h2>Event Templates</h2>
        <ul>
          <li *ngFor="let eventTemplate of getEventTemplateEntries()">
            <code>{{ eventTemplate.id }}</code>{{ eventTemplate.title }}
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="dialogDeleteTemplateRef.close(false)">Cancel</button>
    <button mat-flat-button color="warn" (click)="confirmDeleteAction()">Delete</button>
  </div>
</ng-template>
